var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40 35.5C40.8284 35.5 41.5 34.8284 41.5 34C41.5 33.1716 40.8284 32.5 40 32.5V35.5ZM8 34L6.93934 32.9393C6.35355 33.5251 6.35355 34.4749 6.93934 35.0607L8 34ZM17.0607 27.0607C17.6464 26.4749 17.6464 25.5251 17.0607 24.9393C16.4749 24.3536 15.5251 24.3536 14.9393 24.9393L17.0607 27.0607ZM14.9393 43.0607C15.5251 43.6464 16.4749 43.6464 17.0607 43.0607C17.6464 42.4749 17.6464 41.5251 17.0607 40.9393L14.9393 43.0607ZM40 32.5H8V35.5H40V32.5ZM14.9393 24.9393L6.93934 32.9393L9.06066 35.0607L17.0607 27.0607L14.9393 24.9393ZM6.93934 35.0607L14.9393 43.0607L17.0607 40.9393L9.06066 32.9393L6.93934 35.0607Z",
    fill: "url(#paint0_linear_63_9871)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H40M40 14L32 6M40 14L32 22",
    stroke: "url(#paint1_linear_63_9871)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_9871",
    x1: 7.23478,
    y1: 26,
    x2: 18.7009,
    y2: 51.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45115,
    stopColor: "#A8F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_9871",
    x1: 7.23478,
    y1: 6,
    x2: 18.7009,
    y2: 31.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45115,
    stopColor: "#A8F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.ba3bc26e650cbd540a992a385b245de0.svg";
export { ForwardRef as ReactComponent };